export const BOOKING_LIMIT_MESSAGE =
  'لقد وصلت إلى الحد الأقصى اليومي للحجوزات (20 عملية). يمكنك متابعة التصفح، لكن لا يمكن إنشاء أو تعديل أو إلغاء الحجوزات حالياً. يرجى التواصل مع الإدارة إذا كنت بحاجة للمساعدة.';

export function isBookingLimitError(err) {
  return err?.response?.data?.type === 'booking_limit_reached';
}

export function getBookingLimitMessage(err) {
  return err?.response?.data?.message || BOOKING_LIMIT_MESSAGE;
}
